import { defineComponent as o, getCurrentInstance as s, ref as i } from "vue";
import { MsClose as m } from "@sunrise/icons";
import { setDomainCookie as c } from "@sunrise/shared";
import f from "./index190.js";
const B = o({
  name: "MsSmartBanner",
  components: {
    MsClose: m,
    MsStarsRating: f
  },
  props: {
    smartBannerData: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    var n;
    const a = (n = s()) == null ? void 0 : n.proxy, e = i(t.smartBannerData.showBanner);
    async function r() {
      c(
        t.smartBannerData.cookieKey,
        "true",
        D(t.smartBannerData.expireTimeInDays),
        !0,
        !1
      ), e.value = !1, await (a == null ? void 0 : a.$nextTick());
    }
    return {
      isVisible: e,
      close: r
    };
  }
});
function D(t) {
  const a = Date.now(), e = new Date(a);
  return e.setDate(e.getDate() + t), e;
}
export {
  B as default
};
